import { acceptHMRUpdate, defineStore } from 'pinia'
import { RouteLocationNormalizedGeneric, RouteRecordRaw, useRouter } from 'vue-router'

import routes from '@/lib/utils/routes'

type Breadcrumb = { name: string; link?: string }

type State = {
  path: Breadcrumb[]
}

type Actions = {
  setPath: (to: RouteLocationNormalizedGeneric | Array<{ name: string; link?: string }>) => void
  setPathExtend: (crumbs: Breadcrumb[]) => void
  setCustomPath: (customPath: Breadcrumb[]) => void
}

export const useBreadcrumbsStore = defineStore<string, State, Record<string, never>, Actions>(
  'breadcrumbs',
  {
    state: () => ({
      path: [],
    }),

    actions: {
      setPath(to) {
        if ('meta' in to && to.meta.crumbs) {
          to.meta.crumbs.forEach((el, idx, arr) => {
            el.link = el.link.startsWith('/') ? el.link : `/${el.link}`
            if (idx > 0 && arr[0].link !== '/products') el.link = arr[idx - 1].link + el.link
          })
          this.path = to.meta.crumbs
        } else {
          const path: Breadcrumb[] = []

          const addItem = (start: RouteRecordRaw | undefined) => {
            if (start) {
              path.unshift({
                name: routes.getCaptionByRouteName(start.name as string),
                link: start.path,
              })
              if (start.parent) {
                addItem(routes.find(start.parent))
              }
            }
          }

          const router = useRouter()
          if (!routes.isRoot(router.currentRoute.value.name) && router.currentRoute.value.name) {
            addItem(routes.find(String(router.currentRoute.value.name)))
          }
          this.path = path
        }
      },

      setPathExtend(crumbs) {
        this.path = [...this.path, ...crumbs]
      },

      setCustomPath(customPath) {
        this.path = customPath
      },
    },
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBreadcrumbsStore, import.meta.hot))
}
